/* eslint-disable no-undef */
import React, { useContext } from 'react';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import ThemeContext from '../../../config/themeContext';

export default function AdLoading() {
  const theme = useContext(ThemeContext);

  return (
    <div className="tpx-ext-loading">
      <div className="spin">
        <AutorenewIcon sx={theme.imageIconMedium}></AutorenewIcon>
      </div>
      <div>
        <span>Loading...</span>
      </div>
    </div>
  );
}
